import React from "react";
import "./stakeholders.css";
import { Write, Footer } from "../components";
import "./../App.css";
const Write_page = () => {
  return (
    <div>
      <div className="page">
        <Write />
        <Footer />
      </div>
    </div>
  );
};

export default Write_page;
